export default {
  Host: "wss://codechallenge.brand.live",
  Room: "code-test",
  StorageMessageKey: "_messages_",
  StorageUsernameKey: "_users_",
};
